export enum AccountView {
    OVERVIEW,
    PLATFORMS,
    GENRES,
    WATCHED,
    SAVED,
    SETTINGS,
}
